import React, { PureComponent } from 'react'

import { CSSTransition } from 'react-transition-group'

import styles from './index.scss'
import cx from 'classnames'

class SlideUpModal extends PureComponent {
  static defaultProps = {
    isOpen: false,
  }

  render() {
    const { isOpen, handleClose, children } = this.props
    return (
      <CSSTransition
        in={isOpen}
        onEnter={this.handleEnter}
        onEntering={this.handleEntering}
        onExit={this.handleExit}
        onExited={this.handleExited}
        timeout={400}
        unmountOnExit
      >
        <div className={cx('slideUpModal', { active: isOpen })}>
          <style jsx>{styles}</style>
          <div className="slideUpModal__overlay" onClick={handleClose} />
          <div className="slideUpModal__modal">
            <div className="content">{children}</div>
          </div>
        </div>
      </CSSTransition>
    )
  }

  updateBodyOverflow = (overflow = '') => (window.document.body.style.overflow = overflow)

  handleEnter = () =>
    this.updateBodyOverflow('hidden') && this.props.onEnter && this.props.onEnter()

  handleEntering = () => this.props.onEntering && this.props.onEntering()

  handleExit = () => this.updateBodyOverflow() && this.props.onExit && this.props.onExit()

  handleExited = () => this.props.onExited && this.props.onExited()
}

export default SlideUpModal
